export enum MmAlertDuration {
  short = 5000,
  default = 7000,
  long = 12000
}
